import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import PageHeading from '../components/PageHeading/PageHeading';
import Radio from '../components/Radio/Radio';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const SecurityRecaptcha = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable reCAPTCHA on Signup", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Protect your forms from spam and abuse. Add an extra layer of security to your signup process effortlessly", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable administrator password", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable reCaptcha", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.re_captcha.enable"
                                    checked={settingData?.security?.['re_captcha']?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("reCAPTCHA Version", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Choose your preferred reCAPTCHA version to safeguard user interactions., adipisicing elit. Deserunt, cum.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="title-group">
                            <Radio
                                defaultValues={settingData?.security?.['re_captcha']?.type}
                                options={[
                                    { value: 'v2', label: 'reCAPTCHA keys V2', hint:__("Select recaptcha version", "ultimate-security") },
                                    { value: 'v3', label: 'reCAPTCHA keys V3', hint:__("Select recaptcha version", "ultimate-security") },
                                ]}
                                name="security.re_captcha.type"
                                handleChange= {handleChange}
                                type="block"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Site Key", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Your unique site key is required to integrate reCAPTCHA. It identifies your site and activates security features.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enter site key", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['site_key']}
                                        onChange={(e) => handleChange('security.re_captcha.site_key', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Get it from", "ultimate-security" )} {" "} <a href="https://www.google.com/recaptcha/about/" target="_blank">https://www.google.com/recaptcha/about/</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Secret Key", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("The secret key authenticates communication between your site and reCAPTCHA. Keep it secure to ensure reliable protection.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enter secret key", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['secret_key']}
                                        onChange={(e) => handleChange('security.re_captcha.secret_key', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Get it from", "ultimate-security" )} {" "} <a href="https://www.google.com/recaptcha/about/" target="_blank">https://www.google.com/recaptcha/about/</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Error message reCAPTCHA verification failed", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the text for the error message for failed verification.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set message", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['message_verification_failed']}
                                        onChange={(e) => handleChange('security.re_captcha.message_verification_failed', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "A default message is already added for your convenience.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Error message reCAPTCHA Blank", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the text for the message for blank reCaptcha.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set message", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['message_blank']}
                                        onChange={(e) => handleChange('security.re_captcha.message_blank', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "A default message is already added for your convenience.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Error message for can not connect to server", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the text message for when the server connection fails.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set message", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['message_server_fail']}
                                        onChange={(e) => handleChange('security.re_captcha.message_server_fail', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "A default message is already added for your convenience.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("reCAPTCHA Field Title", "ultimate-security")}</h5>                           
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set reCaptcha title", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['re_captcha']?.['field_title']}
                                        onChange={(e) => handleChange('security.re_captcha.field_title', e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "A default message is already added for your convenience.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("reCAPTCHA Theme", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Choose your preferred reCAPTCHA version to safeguard user interactions.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="title-group">
                            <Radio
                                defaultValues={settingData?.security?.['re_captcha']?.theme}
                                options={[
                                    { value: 'light', label: 'Light', hint:__("Select recaptcha theme", "ultimate-security") },
                                    { value: 'dark', label: 'Dark', hint:__("Select recaptcha theme", "ultimate-security") },
                                ]}
                                name="security.re_captcha.theme"
                                handleChange= {handleChange}
                                type="block"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("reCAPTCHA Size", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Choose your preferred reCAPTCHA version to safeguard user interactions", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="title-group">
                            <Radio
                                defaultValues={settingData?.security?.['re_captcha']?.size}
                                options={[
                                    { value: 'normal', label: 'Normal', hint:__("Select recaptcha size", "ultimate-security") },
                                    { value: 'compact', label: 'Compact', hint:__("Select recaptcha theme", "ultimate-security") },
                                ]}
                                name="security.re_captcha.size"
                                handleChange= {handleChange}
                                type="block"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("No-Conflict Mode", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Resolve conflicts with other scripts or plugins by enabling No-Conflict Mode. Ensure smooth operation without interruptions.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable No-Conflict Mode", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable No-Conflict Mode", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.re_captcha.no_conflict_mode"
                                    checked={settingData?.security?.['re_captcha']?.no_conflict_mode} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg px-lg mt-lg border-top" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("Woo Registration reCAPTCHA", "ultimate-security")}
                    subtitle={__("Add an extra layer of security to your WooCommerce registration form with reCAPTCHA. Prevent bots and automated signups seamlessly.", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pt-lg mt-lg border-top">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable reCAPTCHA on Signup", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Secure your signup forms by enabling reCAPTCHA. Prevent spam and ensure only legitimate users can register.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("reCaptcha on signup", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.re_captcha.enable_woocommerce"
                                    checked={settingData?.security?.['re_captcha']?.enable_woocommerce} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityRecaptcha, 'security.re_captcha');